import * as restApi from "./restApi";
import { assertId } from "./restApi";

const collectionUrl = "api/role";
const enc = encodeURIComponent;

export const existsRecord = restApi.existsRecord.bind(null, {}, collectionUrl);
export const fetchRecord = restApi.fetchRecord.bind(null, {}, collectionUrl);
export const fetchRecords = restApi.fetchRecords.bind(null, {}, collectionUrl);
export const updateRecord = restApi.updateRecord.bind(null, {}, collectionUrl);
export const insertRecord = restApi.insertRecord.bind(null, {}, collectionUrl);
export const deleteRecord = restApi.deleteRecord.bind(null, {}, collectionUrl);

export const addRolePermission = function (roleId, permissionId) {
  assertId(roleId) && assertId(permissionId);
  return restApi.updateRecord({}, `${collectionUrl}/${enc(roleId)}/permissions`, permissionId, {});
};

export const removeRolePermission = function (roleId, permissionId) {
  assertId(roleId) && assertId(permissionId);
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(roleId)}/permissions`, permissionId);
};
